/**
 * given a string, trim and return the first word
 * @param  {String} [str=""] input string, ie naics code and description
 * @return {String}          first word in the input string
 */
export default function getFirstWord(str:string="") {
  str = str.trim()
  return str.replace(/ .*/,'')
}
